import Swiper from 'swiper/bundle';
import { Breakpoint } from '~/lib/utils/breakpoint';
export const createCarousel = (els) => {
    const cls = 'carousel';
    const slideCls = `${cls}-item`;
    const buttonCls = `${cls}__btn`;
    const paginationCls = `${cls}__pagination`;
    const swiper = new Swiper(els.swiper, {
        slidesPerView: 1,
        spaceBetween: 80,
        wrapperClass: 'js-carousel-items',
        slideClass: slideCls,
        noSwipingClass: `${cls}--no-swiping`,
        slideNextClass: `${slideCls}--next`,
        slidePrevClass: `${slideCls}--prev`,
        slideBlankClass: `${slideCls}--blank`,
        slideActiveClass: `${slideCls}--active`,
        slideVisibleClass: `${slideCls}--visible`,
        lazyPreloaderClass: `${cls}__lazy-preloader`,
        slideFullyVisibleClass: `${slideCls}--fully-visible`,
        containerModifierClass: `${cls}--`,
        navigation: {
            prevEl: els.prevBtn,
            nextEl: els.nextBtn,
            hiddenClass: `${buttonCls}--hidden`,
            lockClass: `${buttonCls}--locked`,
            disabledClass: `${buttonCls}--disabled`,
            navigationDisabledClass: `${cls}__navigation--disabled`,
        },
        pagination: {
            el: null,
            clickable: true,
            bulletClass: `${paginationCls}-bullet`,
            bulletActiveClass: `${paginationCls}-bullet--active`,
            clickableClass: `${paginationCls}--clickable`,
            currentClass: `${paginationCls}--current`,
            hiddenClass: `${paginationCls}--hidden`,
            horizontalClass: `${paginationCls}--horizontal`,
            modifierClass: `${paginationCls}--`,
            paginationDisabledClass: `${paginationCls}--disabled`,
            lockClass: `${paginationCls}--locked`,
            progressbarFillClass: `${paginationCls}-progressbar--fill`,
            progressbarOppositeClass: `${paginationCls}-progressbar--opposite`,
            totalClass: `${paginationCls}-total`,
            verticalClass: `${paginationCls}--vertical`,
        },
        breakpoints: {
            [Breakpoint.MD]: {
                slidesPerView: 2,
            },
            [Breakpoint.LG]: {
                slidesPerView: 3,
            },
            [Breakpoint.XL]: {
                slidesPerView: 4,
            },
        },
    });
    /**
     * Updates the locked state of the carousel.
     */
    const updateLocked = () => {
        els.swiper.classList.toggle(cls + '--locked', swiper.isLocked);
    };
    updateLocked();
    swiper.on('lock', updateLocked);
    swiper.on('unlock', updateLocked);
    return swiper;
};
